<div class="add-dialog w600">
  <h1 mat-dialog-title>Zu Sammelmappe hinzufügen</h1>
  <mat-dialog-content>
    <p class="intro">{{ entryText(itemCount) }} ausgewählt. Bereits enthaltene Einträge werden übersprungen.</p>

    <mat-form-field appearance="outline" class="w100" subscriptSizing="dynamic">
      <mat-label>Sammelmappe suchen</mat-label>
      <input [formControl]="searchCtrl" matInput type="search">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <mat-radio-group [(ngModel)]="selected" class="folder-options custom-scrollbar">
      <mat-radio-button [value]="newFolder" class="folder-option">
        <span class="folder-option-name"><mat-icon inline>create_new_folder</mat-icon> Neue Sammelmappe</span>
      </mat-radio-button>
      @if (selected === newFolder) {
        <mat-form-field appearance="outline" class="new-folder-name">
          <mat-label>Name der neuen Sammelmappe</mat-label>
          <input (keyup.enter)="submit()" [formControl]="nameCtrl" matInput required type="text">
          @if (nameCtrl.hasError('required') && nameCtrl.touched) {
            <mat-error>Name ist verpflichtend</mat-error>
          }
          @if (nameCtrl.hasError('maxlength')) {
            <mat-error>Nur 256 Zeichen erlaubt</mat-error>
          }
        </mat-form-field>
      }

      @if (loading) {
        <div class="center-content pad16">
          <mat-progress-spinner diameter="32" mode="indeterminate"></mat-progress-spinner>
        </div>
      } @else {
        @for (folder of folders; track folder.id) {
          <mat-radio-button [value]="folder.id" class="folder-option">
            <span class="folder-option-name">{{ folder.name }}</span>
            <span class="gray folder-option-info">
              {{ folder.itemCount }}/{{ maxItems }} Einträge
              @if (folder.access !== 'OWNER') {
                · geteilt von {{ folderUserName(folder.owner) }}
              }
            </span>
          </mat-radio-button>
        } @empty {
          <p class="gray pad16 m0">
            @if (searchCtrl.value) {
              Keine passende Sammelmappe gefunden.
            } @else {
              Sie haben noch keine Sammelmappe, die Sie bearbeiten dürfen.
            }
          </p>
        }
      }
    </mat-radio-group>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-dialog-close mat-raised-button>Abbrechen</button>
    <button (click)="submit()" [disabled]="!canSubmit()" color="primary" mat-raised-button>Hinzufügen</button>
  </mat-dialog-actions>
</div>
